import React, { useState, useEffect } from 'react';
import { WifiOff, RefreshCw } from 'lucide-react';
import API from '@/config/api';

const ConnectivityBanner = () => {
  const [offline, setOffline] = useState(false);
  const [checking, setChecking] = useState(false);

  const checkHealth = async () => {
    try {
      const res = await fetch(`${API}/health`, { method: 'GET', cache: 'no-store' });
      if (res.ok) {
        setOffline(false);
        return;
      }
      setOffline(true);
    } catch {
      setOffline(true);
    }
  };

  useEffect(() => {
    checkHealth();
    const interval = setInterval(checkHealth, 30000);
    return () => clearInterval(interval);
  }, []);

  const handleRetry = async () => {
    setChecking(true);
    await checkHealth();
    setChecking(false);
  };

  if (!offline) return null;

  return (
    <div
      data-testid="connectivity-banner"
      className="fixed top-0 left-0 right-0 z-[9999] bg-red-600 text-white px-4 py-2.5 flex items-center justify-center gap-3 text-sm font-medium shadow-lg"
    >
      <WifiOff className="w-4 h-4 flex-shrink-0" />
      <span>Unable to connect to server. Please check your connection.</span>
      <button
        data-testid="connectivity-retry-btn"
        onClick={handleRetry}
        disabled={checking}
        className="inline-flex items-center gap-1.5 px-3 py-1 bg-white/20 hover:bg-white/30 rounded text-xs font-semibold transition-colors disabled:opacity-50"
      >
        <RefreshCw className={`w-3 h-3 ${checking ? 'animate-spin' : ''}`} />
        {checking ? 'Checking...' : 'Retry'}
      </button>
    </div>
  );
};

export default ConnectivityBanner;
